import React, {useState, useEffect} from 'react';
import OtpInput from 'react-otp-input';

export default function VerifyCode(props) {
  const {checkCode, codeValidationFailed, maxDigits, resetCode} = props;
  const [OTP, setOTP] = useState('');

  useEffect(() => {
    setOTP('');
  }, [resetCode]);

  const verifycodeHandler = () => {
    if (OTP.length === maxDigits) {
      checkCode(OTP);
    }
  };

  return (
    <>
      <div className="verify-code-form p-3">
        <OtpInput
          value={OTP}
          onChange={setOTP}
          shouldAutoFocus={true}
          numInputs={maxDigits}
          separator={<span>-</span>}
        />
      </div>
      <div className="pt-5 w-100">
        <button
          className="btn btn-lg btn-dark w-100"
          onClick={verifycodeHandler}
          style={{backgroundColor: `${OTP.length === maxDigits ? '' : 'gray'}`}}
        >
          {'Verify Code'}
        </button>
      </div>
      {resetCode && (
        <div className="text-center mt-3 text-success">
          {'Verification code has been resent'}
        </div>
      )}
      {codeValidationFailed && (
        <div className="text-center mt-3 text-danger">{'Invalid Code'}</div>
      )}
    </>
  );
}
